import { Component, inject, Input, OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { PropertyDetails, RelatedAuction } from 'src/app/services/portal-api.service';
import { ClickOutsideDirective } from 'src/app/shared/directives/click-outside.directive';
import { LanguageRouterLinkDirective } from 'src/app/shared/directives/language-router-link.directive';
import { NavigationBehaviorOptions, RouterLink } from '@angular/router';
import { max, maxBy } from 'lodash';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-auction-section',
  standalone: true,
  imports: [CommonModule, DatePipe, CurrencyPipe, LanguageRouterLinkDirective,TranslocoDirective, ClickOutsideDirective],
  templateUrl: './auction-section.component.html',
  styleUrl: './auction-section.component.css'
})
export class AuctionSectionComponent implements OnInit {
  @Input() model = new PropertyDetails();

  translocoService = inject(TranslocoService);
  locale: string = '';
  isDropdownOpen = false;
  discount = 0;
  hasRelatedAuction = false
  activeRound$: BehaviorSubject<number> = new BehaviorSubject<number>(1)

  ngOnInit(): void {
    this.locale = this.translocoService.getActiveLang();
    this.translocoService.langChanges$.subscribe((activeLocale) => {
      this.locale = activeLocale
    });
    this.activeRound$.subscribe((roundNumber) => {
      this.setDiscount(roundNumber)
    });

    if (this.model.auctionRounds?.rounds && this.model.auctionRounds?.rounds?.length > 0) {
      let maxRound = maxBy(this.model.auctionRounds.rounds, (r) => { return r.roundNumber })?.roundNumber ?? 1
      this.activeRound$.next(maxRound);
    }
    this.hasRelatedAuction = (this.model.auctionRounds?.relatedAuctions && this.model.auctionRounds?.relatedAuctions.length > 0) ?? false

  }

  setActiveRound(roundNumber: number) {
    this.activeRound$.next(roundNumber);
  }
  private setDiscount(roundNumber: number) {
    const firstPrice = this.model.auctionRounds?.rounds?.[0]
    const currentPrice = this.model.auctionRounds?.rounds?.[roundNumber - 1]
    this.discount = ((firstPrice?.startingPrice ?? 0) - (currentPrice?.startingPrice ?? 0)) / (firstPrice?.startingPrice ?? 1) * 100
    this.discount = Math.floor(this.discount)
  }
}
